import TermsOptions from './TermsOptions'

export default TermsOptions
